module.exports = __webpack_public_path__ + "static/media/img-starter-kit.163d1447.svg";